export default "__VITE_ASSET__BT7hkX3U__"